import { __assign } from "tslib";
import { createOmnichannelDashboardApi } from '.';
import { createHttpTestKit } from '../../http/test-kit';
import { createFakePostResponder } from '../../test-utils';
export var createOmnichannelDashboardApiTestkit = function (parent) {
    if (parent === void 0) { parent = 'localhost'; }
    var fakeHttp = createHttpTestKit();
    var api = createOmnichannelDashboardApi(parent, fakeHttp);
    var base = parent + "/dashboard/omnichannel";
    var handler = {
        whenGetDashboardData: createFakePostResponder(fakeHttp, "" + base),
    };
    return __assign(__assign({}, api), handler);
};
//# sourceMappingURL=testkit.js.map